import React, { Component } from "react";
import Slider from "react-slick";
import BannerImg1 from "../assets/images/banner/banner-home1.png";

import AviatorBanner from "../assets/images/banner/home/AviatorBanner.jpg";
import AviatorBannerMob from "../assets/images/banner/home/Aviator-Banner.png";
import { RouteType, useAppNavigate } from "../hooks/useAppNavigate";

const MainSlider = ({ banners }) => {
  const settings = {
    arrows: false,
    dots: false,
    swipeToSlide: true,
    infinite: true,
    autoplay: true,

    slidesToShow: 1,
    slidesToScroll: 1,

    speed: 3000,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };
  const { appNavigate } = useAppNavigate();
  return (
    <div className="MainSliderSection">
      <div className="SliderSection">
        <Slider {...settings}>
          {banners &&
            banners.length &&
            banners.map((b, index) => {
              return (
                <div className="img_box" key={index}>
                  <img src={b.link} alt="First Slide" />
                </div>
              );
            })}
        </Slider>
      </div>

      <div className="ManualSlider">
        <ul>
          <li className="d-none ">
            <a
              href="javascript:void(0)"
              onClick={() => appNavigate("/referral", RouteType.Protected)}
            >
              <div className="InviteFriend">
                <div className="button_text-wrapper">
                  <h3>Invite Friends</h3>
                  <span>Get Cashback!</span>
                </div>
              </div>
            </a>
          </li>
          <li className="d-none ">
            <a
              href="javascript:void(0)"
              onClick={() => appNavigate("/bonus", RouteType.Protected)}
            >
              <div className="InviteFriend Bonus">
                <div className="button_text-wrapper">
                  <h3>Welcome Bonus</h3>
                </div>
              </div>
            </a>
          </li>

          <li className="d-md-block d-none ">
            <a
              // href="/casino/aggapspribe-aviator"
              href="javascript:void(0)"
              onClick={() =>
                appNavigate("/casino/aggapspribe-aviator", RouteType.Protected)
              }
            >
              <img src={AviatorBanner} alt="AvaitorBanner" />
            </a>
          </li>
          <li className="d-md-none AviatorSection">
            <a
              href="javascript:void(0)"
              onClick={() =>
                appNavigate("/casino/aggapspribe-aviator", RouteType.Protected)
              }
            >
              <img src={AviatorBannerMob} alt="AvaitorBanner" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MainSlider;
